/* Product card photo swipe — dots, chevrons, drag-vs-tap.
   Idempotent; re-boots on section load, Shopify AJAX pagination, and chip-bar swaps. */
(function () {
  'use strict';
  var THRESH = 10;

  function initTrack(track) {
    if (track.__pi) return; track.__pi = true;
    var card = track.closest('.product-item__aspect-ratio') || track.parentNode;
    var dots = card.querySelectorAll('.pi-swipe__dot');

    if (dots.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
          ticking = false;
        });
      }, { passive: true });
    }

    var prev = card.querySelector('[data-pi-prev]');
    var next = card.querySelector('[data-pi-next]');
    function nav(e, dir) { e.preventDefault(); e.stopPropagation(); track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function (e) { nav(e, -1); });
    if (next) next.addEventListener('click', function (e) { nav(e, 1); });

    var sx = 0, sy = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; }, { passive: true });
    track.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - sx) > THRESH || Math.abs(e.clientY - sy) > THRESH) moved = true; }, { passive: true });
    var link = (card.tagName === 'A') ? card : card.closest('a');
    if (link) link.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  function boot() { document.querySelectorAll('[data-pi-track]').forEach(initTrack); }
  window.__piSwipeBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);

  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(boot, 120); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
